export default __webpack_public_path__ + "a554ecc73f1b6309a71674011f620f1a.png";